import style from "../../Pages/ServicesDisplay.module.css";
import microATM from "../images/microatm.png";

const MicroAtm = () => {
  return (
    <article className={style.ServiceDetailArticle}>
      <h1>Micro ATM</h1>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <picture>
          <img src={microATM}></img>
        </picture>
      </div>
      <p className={style.Paragraph}>
        <strong>
          Payments Bank has rolled out an Android-based point-of-sale (PoS)
          device to ramp up its door-to-door banking services. ... It is
          interoperable and will allow even customers with debit cards issued by
          other banks to do payments and withdrawals at banking points.
        </strong>
        <br /> <br />- We at centres provides the Card Pay facility, most of the
        population till now is not able to use their debit card provided by the
        banks and they not know how to use them by swipe machines through which
        banks can remotely connect to their core banking system. This machine
        comes with a fingerprint scanner attached to it. In other words, micro
        ATMs are handheld point of sale terminals used to disburse cash in
        remote locations where bank branches cannot reach and through this an
        awareness campaign is initiated to make aware about the card use to the
        unprivileged and untapped population who is availing the banking
        services.
      </p>
    </article>
  );
};

export default MicroAtm;
